export const DefaultCommunicationSrcType = {
	None: 'None',
	notifyEmail: 'notifyEmail',
	notifySMS: 'notifySMS',
	notifyWhatsapp: 'notifyWhatsapp',
} as const;
export type DefaultCommunicationSrcType = (typeof DefaultCommunicationSrcType)[keyof typeof DefaultCommunicationSrcType];
